import { deleteRequest } from '..';

const deleteTicket = (ticketId: string) => deleteRequest(`assets/tickets/${ticketId}`);

export default deleteTicket;
